/* eslint-disable */

import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * @param idAnnonceur
 * @returns {Promise<unknown>}
 */
export async function getAnnonceurMailtracking(idAnnonceur) {
    return HTTP_HYPER_ESPACE_BACKEND
        .get("/annonceur-mailtracking/" + idAnnonceur)
        .then(async response => {
                return response.data;
        })
        .catch(error => {
            return error;
        });
}

export async function updateAnnonceurMailtracking(idAnnonceur, data) {
    return HTTP_HYPER_ESPACE_BACKEND
        .post("/annonceur-mailtracking/" + idAnnonceur, data)
        .then(async response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
}

export async function decryptData(data) {
    return HTTP_HYPER_ESPACE_BACKEND
        .post("/decrypt-data", data)
        .then(async response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
}